import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from "../ModuleBlock";
import withTranslation from "../../../../../hoc/withTranslation";
import ModuleService from "../../../../../services/module";
import {List, ListItem} from 'material-ui/List';
import styles from './DynamicLinkModuleBlock.css';
import Error from 'material-ui/svg-icons/alert/error';
import { white } from 'material-ui/styles/colors';

class DynamicLinkModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {

        let content = null;

        const isConfigOK = this.props.app.configurations.dynamic_links_domain !== null
            && this.props.app.configurations.dynamic_links_link !== null
            && (
                this.props.app.configurations.android_package_name !== null
                || (
                    this.props.app.configurations.ios_bundle_id !== null
                    && this.props.app.configurations.ios_app_store_id !== null
                )
            );

        if (!isConfigOK) {
            content = <List>
                <ListItem
                    style={styles.list}
                    disabled={true}
                    primaryText={this.props.t('module.dynamic_link.configuration_ko')}
                    leftIcon={<Error color={white}/>}/>
            </List>;
        }

        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.DYNAMIC_LINK)} content={content}/>
        );
    }
}

export default withTranslation(DynamicLinkModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/DynamicLinkModuleBlock/DynamicLinkModuleBlock.js